export default __webpack_public_path__ + "assets/images/ilustracaoPagamentoAdicionado2523973ed3cec836e69c4c3b10ad1d68.png";